// src/Inicio.js
import React, { Component } from 'react';
import i18n from './I18N/I18n.js'; 
import Cookies from 'js-cookie';
import './css/inicio.css'; // Importar los estilos
import { cargarIdiomaPreferido} from './functions.js';
import cewyLogo from './img/logo.jpg';

class Inicio extends Component {
  async componentDidMount() {
    Cookies.remove('email');
    Cookies.remove('id');
    Cookies.remove('rol');
    Cookies.remove('direccion');
    Cookies.remove("direccion2")
    Cookies.remove("direccion3")
    await cargarIdiomaPreferido(this.cambiarIdioma);
  }

  cambiarIdioma = (idioma) => {
    i18n.changeLanguage(idioma); 
    this.forceUpdate(); 
    Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
  };

  render() {
    return (
      <div className="container">
        <div className="content">
          <h1 className="title">Admin-Certifica-T.App</h1>
          <img src={cewyLogo} alt="Cewy Logo" className="logo" />

          <div className="buttonContainer">

            <button
              className="button"
              onClick={() => {
                window.location.href = `/logIn`;
              }}
            >
              Log in
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Inicio;
